import { demoClients } from '../data/clients';
import { error, route, type DemoRoute } from '../router';

function listClients(query: URLSearchParams) {
  const q = (query.get('q') ?? '').toLowerCase();
  const status = query.get('status');
  const limit = Number(query.get('limit') ?? 1000);
  const offset = Number(query.get('offset') ?? 0);
  let clients = demoClients;
  if (status) clients = clients.filter((c) => c.status === status);
  if (q) clients = clients.filter((c) => c.name.toLowerCase().includes(q));
  return {
    clients: clients.slice(offset, offset + limit),
    total: clients.length,
    limit,
    offset,
    query: q || undefined,
  };
}

export const clientHandlers: DemoRoute[] = [
  route('GET', '/clients', ({ query }) => listClients(query)),
  route('GET', '/clients/', ({ query }) => listClients(query)),
  route('GET', '/clients/:id', ({ params }) => {
    const client = demoClients.find((c) => c.id === params.id);
    return client ? { client } : error(404, 'Client not found');
  }),
  route('PATCH', '/clients/:id', ({ params, body }) => {
    const client = demoClients.find((c) => c.id === params.id);
    if (!client) return error(404, 'Client not found');
    Object.assign(client, body as object, { updated_at: new Date().toISOString() });
    return { message: 'Client updated', client };
  }),
  route('POST', '/clients', () => error(409, 'Демо режим: добавянето на клиенти е изключено')),
  route('DELETE', '/clients/:id', () => error(409, 'Демо режим: изтриването на клиенти е изключено')),
];
